import { Directive, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { History } from '@df/session/api/history/history';
import { HistoryOrder, IHistoryTrackingItem } from '@df/session/api/history/history-order';
import { HistoryOrderItem } from '@df/session/api/history/history-order-item';
import { UiComponent } from '@df/ui/ui.component';

@Directive()
export abstract class AccountOrderViewComponentDef extends UiComponent implements OnInit {
    /**
     * Viewed order
     */
    order?: HistoryOrder;

    private route = inject(ActivatedRoute);
    private history = inject(History);

    /**
     * Initialize order
     */
    override ngOnInit() {
        const params = this.route.snapshot.params;
        this.order = this.history.byId(params ? parseInt(params['id'], 10) : 0);
        super.ngOnInit();
    }

    /**
     * Tracking function
     */
    orderItemTrackFn(index: number, item: HistoryOrderItem): number {
        return item.id;
    }

    get tracking(): IHistoryTrackingItem[] | undefined {
        const tracking = this.order?.data.tracking;
        return tracking ? Object.values(tracking) : undefined;
    }
}
